import React, { useState, createContext } from "react";

export const BaseContext = createContext();

export const BaseProvider = (props) => {
  const [token, setToken] = useState(
    localStorage.getItem("token") ? localStorage.getItem("token") : ""
  );
  const [user, setUser] = useState(
    localStorage.getItem("user") ? localStorage.getItem("user") : ""
  );
  const [email, setEmail] = useState(
    localStorage.getItem("email") ? localStorage.getItem("email") : ""
  );

  const dataBase = {
    token: token,
    setToken: setToken,
    user: user,
    setUser: setUser,
    email: email,
    setEmail: setEmail,
  };

  return (
    <BaseContext.Provider value={dataBase}>
      {props.children}
    </BaseContext.Provider>
  );
};
